'use client'
import StyledComponentsRegistry from "@/lib/registry";
import 'bootstrap/dist/css/bootstrap.min.css';
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import GlobalStyle from "@/styles/globalStyle";
import ErrorBoundary from "@/components/meta/ErrorBoundary";
import SEO from "@/components/meta/SEO";
import { usePathname } from "next/navigation";
import { useSmoothScroll } from "@/components/hooks/useSmoothScroll";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { ScrollSmoother } from "gsap/dist/ScrollSmoother";
import { ScrollToPlugin } from "gsap/dist/ScrollToPlugin";
import { FadeUp, ParallaxX, ParallaxXR, ParallaxXX, splitLeft, SplitUp } from "@/components/animation/TextAnimations";
import HasprCursor from 'haspr-cursor' // Import Wrapper
import { useEffect, useMemo, useRef, useState } from "react";
import Footer from "@/components/Footer";
import MobileMenu from "@/components/global/MobileMenu";
import DesktopMenu from "@/components/global/DesktopMenu";
import { ShowSettingProvider } from "@/app/ShowSettingProvider";
import useDeviceTypeTab from "@/components/hooks/useDeviceTypeTab";
import StickyButton from "@/components/StickyButton";

// import css
import "./global.css";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "swiper/css/effect-fade";
import 'swiper/css/thumbs';
import 'swiper/css/free-mode';
import 'haspr-cursor/dist/cursor.css'
import PageTransition from "@/components/PageTransition";
import SubscribeForm from "@/components/forms/SubscribeForm";
import StickyButtonNumber from "@/components/StickyButtonNumber";
import { getOptions } from "@/api";


gsap.registerPlugin(ScrollTrigger, ScrollSmoother, ScrollToPlugin);


export default function RootLayout({ children }) {
    const pathName = usePathname();
    const siteUrl = process.env.NEXT_PUBLIC_SITE_URL || 'https://localhost:3000';
    const [showSetting, setShowSetting] = useState(false);
    const smoothWrapperRef = useRef(null);


    // is mobile hook - components/hooks/useDeviceType
    const isMobile = useDeviceTypeTab();


    // use SmoothScroll Features - components/hooks/useSmoothScroll
    const el = useSmoothScroll(isMobile, smoothWrapperRef);
    const [isProjectPage, setIsProjectPage] = useState(false);
    const [isLandowner, setIsLandowner] = useState(false);


    // Memoize pathname regex checks to prevent recalculations
    const isProjectOrEventPage = useMemo(() => {
        const newsEventsRegex = /^\/news-events\/[^/]+$/;
        const ProjectsRegex = /^\/project\/[^/]+$/;
        return {
            isLandowner: newsEventsRegex.test(pathName),
            isProjectPage: pathName === '/project' || ProjectsRegex.test(pathName),
        };
    }, [pathName]);



    useEffect(() => {
        // Set states based on memoized regex results
        setIsLandowner(isProjectOrEventPage.isLandowner);
        setIsProjectPage(isProjectOrEventPage.isProjectPage);
    }, [isProjectOrEventPage]);


    const [options, setOptions] = useState({});

    useEffect(() => {
        const fetchOptions = async () => {
            try {
                const data = await getOptions();
                setOptions(data);
            } catch (error) {
                console.error("Failed to fetch options:", error);
            }
        };
        fetchOptions();
    }, []);



    // Animation all Initialize
    splitLeft();
    ParallaxX();
    ParallaxXR();
    FadeUp();
    SplitUp();
    ParallaxXX()




    return (
        <ShowSettingProvider showSetting={showSetting} suppressHydrationWarning={true}>
            <html lang="en">
                <SEO
                    title="Unimass Property Solutions Ltd."
                    description="Unimass is working in Dhaka, Bangladesh especially in Real Estate Sector to Provide Apartment complexes in different prominent locations of Dhaka City at present. Our vision is to expand its efforts to grow profitably by meeting customer needs and satisfaction by establishing direct relationships with our customers. Considering good ecological demand we will accomplish this by responding to changing market conditions; building a performance driven culture that continues to provide our customers with the highest quality residence and commercial complexes; by improving job site productivity through effective job controls; maintaining a secure workplace and utilizing the latest technology; and by creating an environment that encourage growth and development of our people."
                    keywords="Keyword 1, Keyword 2 , Keyword 3, Keyword 4"
                    author="Unimass Property Solutions Ltd."
                    url={`${siteUrl}${pathName}`}
                    image="/images/static/Vector.svg"
                    twitterHandle=""
                    facebookVerification={options?.facebook_varification}
                    googleVerification={options?.google_search_console}
                    canonical={`${siteUrl}${pathName}`}
                />
                <body>
                    <StyledComponentsRegistry>
                        <HasprCursor>
                            <ErrorBoundary>
                                <GlobalStyle />
                                <ToastContainer />
                                {
                                    pathName === '/' &&
                                    <PageTransition />
                                }




                                <StickyButton svg={'<svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                                    '                    <circle cx="25" cy="25" r="25" fill="#1BD741"/>\n' +
                                    '                    <circle class="circle" cx="25" cy="25" r="0" fill="#F27A21"/>\n' +
                                    '                    <path d="M13 37L14.679 31.0367C13.5993 29.2025 13.0308 27.1155 13.0308 24.9716C13.0308 18.3704 18.4013 13 25.0024 13C31.6036 13 36.974 18.3704 36.974 24.9716C36.974 31.5728 31.6036 36.9432 25.0024 36.9432C22.9456 36.9432 20.9315 36.4167 19.1497 35.417L13 37ZM19.4641 33.239L19.8306 33.4628C21.384 34.4111 23.1725 34.9124 25.0024 34.9124C30.4838 34.9124 34.9432 30.453 34.9432 24.9716C34.9432 19.4902 30.4838 15.0308 25.0024 15.0308C19.5211 15.0308 15.0616 19.4902 15.0616 24.9716C15.0616 26.8815 15.6044 28.7362 16.6313 30.3352L16.878 30.7195L15.9112 34.1536L19.4641 33.239Z" fill="white"/>\n' +
                                    '                    <path d="M21.6394 19.3996L20.8626 19.3573C20.6186 19.344 20.3793 19.4255 20.1949 19.5857C19.8183 19.9128 19.2161 20.545 19.0312 21.3689C18.7554 22.5974 19.1816 24.1017 20.2848 25.6059C21.3879 27.1102 23.4438 29.5171 27.0791 30.545C28.2505 30.8763 29.1721 30.653 29.8831 30.1981C30.4462 29.8379 30.8344 29.2598 30.9743 28.6062L31.0983 28.0269C31.1377 27.8427 31.0442 27.6559 30.8732 27.5771L28.2478 26.367C28.0774 26.2884 27.8753 26.3381 27.7607 26.4866L26.73 27.8227C26.6522 27.9237 26.5189 27.9637 26.3985 27.9214C25.6927 27.6734 23.3284 26.6832 22.0312 24.1842C21.9749 24.0759 21.9889 23.9443 22.0687 23.8519L23.0537 22.7124C23.1543 22.596 23.1798 22.4324 23.1193 22.291L21.9876 19.6434C21.9274 19.5025 21.7924 19.408 21.6394 19.3996Z" fill="white"/>\n' +
                                    '                </svg>'} />
                                <StickyButtonNumber
                                    svg={'<svg enable-background="new 0 0 40 40" height="40px"  id="Layer_1" version="1.1" viewBox="0 0 40 40" width="40px">\n' +
                                        '                        <circle cx="20" cy="20" r="20" fill="#1BD741"/>\n' +
                                        '                        <circle class="circle" cx="20" cy="20" r="0" fill="#F27A21"/>\n' +
                                        '                        <path clip-rule="evenodd" d="M14.371,9.793c1.207-0.228,1.998,1.133,2.6,2.072   c0.586,0.912,1.307,1.982,1.016,3.169c-0.162,0.666-0.764,1.029-1.219,1.422c-0.449,0.388-1.133,0.744-1.299,1.34   c-0.271,0.967,0.322,1.982,0.689,2.56c0.834,1.306,1.842,2.483,3.129,3.534c0.623,0.51,1.488,1.191,2.355,1.016   c1.295-0.262,1.637-1.859,3.047-2.072c1.342-0.203,2.25,0.77,3.008,1.422c0.73,0.631,1.908,1.439,1.828,2.52   c-0.047,0.621-0.545,1.006-0.977,1.381c-0.439,0.383-0.824,0.813-1.258,1.096c-1.051,0.686-2.34,1.022-3.82,0.976   c-1.451-0.045-2.607-0.538-3.656-1.097c-2.051-1.094-3.672-2.633-5.199-4.348c-1.502-1.686-2.889-3.682-3.656-5.889   c-0.957-2.756-0.451-5.587,1.098-7.353c0.262-0.3,0.676-0.613,1.055-0.935C13.49,10.284,13.84,9.893,14.371,9.793z" fill="#fff" fill-rule="evenodd"/>\n' +
                                        '                    </svg>'} />
                                {
                                    isMobile ?
                                        <MobileMenu isProjectPage={isProjectPage} isLandowner={isLandowner} />
                                        :
                                        <DesktopMenu isProjectPage={isProjectPage} isLandowner={isLandowner} />
                                }
                                <div ref={el} id="smooth-wrapper" style={{ opacity: 1 }}>

                                    <div id="smooth-content">
                                    {/* <Suspense fallback={null}>
                                        <FacebookPixel />
                                    </Suspense> */}
                                        {children}
                                        <SubscribeForm />
                                        <Footer />
                                    </div>
                                </div>

                            </ErrorBoundary>
                        </HasprCursor>
                    </StyledComponentsRegistry>
                </body>
            </html>
        </ShowSettingProvider>
    );
}


